import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom, filter } from 'rxjs/operators';
import { push } from 'connected-react-router';
import { Actions } from '../../actions';
import { GET_ARTISTS_SUCCESS } from '../actions';
import AppState from '../../state';
import { GET_USER_INVITES_SUCCESS } from '../../invites/actions';
import { NoOp } from '../../ui/action-creators';
import { GET_RECORD_LABELS_SUCCESS } from '../../record-labels/actions';
import { hasProLabel } from '../../subscription/selectors';

const excludedLocations = (pathname: string) => {
  return (
    pathname.startsWith('/onboarding') ||
    pathname === '/user/invites' ||
    pathname.startsWith('/payment') ||
    pathname.startsWith('/plans')
  );
};

export const validateOnboardingEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions>(
      GET_ARTISTS_SUCCESS,
      GET_USER_INVITES_SUCCESS,
      GET_RECORD_LABELS_SUCCESS
    ),
    withLatestFrom(state$),
    filter(([_, state]) => {
      return (
        !excludedLocations(state.router.location.pathname) &&
        !hasProLabel(state)
      );
    }),
    map(([_, state]) => {
      if (
        state.invites.loaded &&
        state.artist.loaded &&
        state.recordLabels.loaded
      ) {
        if (!state.artist.myArtists.length && !state.recordLabels.list.length) {
          return push('/catalog');
        }
      }

      return new NoOp();
    })
  );
